import { FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import { AdvertPhotoType } from '@edikk-edikk/country-common';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import galleryThumbnailCss from '../../../assets/gallery/gallery-thumbnail.module.scss';
import { useGalleryContext } from '#advertDetail/components/gallery';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  photo: AdvertPhotoType;
  index: number;
};

const GalleryThumbnail: FC<PropsType> = ({
  photo,
  index,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();
  const withBlur = useMemo(() => !isBot && isDeleted, [isBot, isDeleted]);
  const { activePhotoIndex, refSwiperOriginalList } = useGalleryContext();

  const handlerClick = useCallback(() => {
    refSwiperOriginalList.current.slideToLoop(index);
  }, [index, refSwiperOriginalList]);

  return (
    <div
      className={classNames(
        swiperCss.swiper__slide,
        galleryThumbnailCss.galleryThumbnail,
        { [galleryThumbnailCss.galleryThumbnail_active]: activePhotoIndex === index },
      )}
      onClick={handlerClick}
      role="presentation"
    >
      <img
        src={photo.url}
        className={classNames(
          galleryThumbnailCss.galleryThumbnail__img,
          { [galleryThumbnailCss.galleryThumbnail__img_withBlur]: withBlur },
        )}
      />
    </div>
  );
};

export { GalleryThumbnail };
